// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mh {
  --mh-navy: #0b1f33;
  --mh-ink: #1e1e1e;
  --mh-muted: #5c6570;
  --mh-hall: #f7f8fa;
  --mh-white: #ffffff;
  --mh-blue: #0877bc;
  --mh-blue-dark: #065a8f;
  --mh-peach: #ffefdd;
  --mh-sage: #0f7b6c;
  --mh-line: rgba(11, 31, 51, 0.1);
  --mh-ease: cubic-bezier(0.25, 1, 0.5, 1);
  color: var(--mh-ink);
  background: var(--mh-hall);
  font-family: Poppins, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  min-height: 100dvh;
  overflow-x: hidden;
}

.mh-sr,
.mh-skip {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.mh-skip:focus {
  position: fixed;
  top: 8px;
  left: 8px;
  z-index: 80;
  width: auto;
  height: auto;
  clip: auto;
  margin: 0;
  padding: 8px 12px;
  background: var(--mh-white);
  color: var(--mh-navy);
}

.mh :focus-visible {
  outline: 2px solid var(--mh-blue);
  outline-offset: 3px;
}

html {
  scroll-behavior: smooth;
}

.mh-section,
.mh-hero,
[id] {
  scroll-margin-top: 92px;
}

@media (max-width: 960px) {
  .mh-section,
  .mh-hero,
  [id] {
    scroll-margin-top: 84px;
  }
}

.mh-wrap {
  width: min(1120px, calc(100% - 40px));
  margin: 0 auto;
}

/* ==========================================================================
   NAVIGATION
   ========================================================================== */

.mh-nav {
  position: sticky;
  top: 0;
  z-index: 50;
  background: rgba(247, 248, 250, 0.78);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  border-bottom: 1px solid transparent;
  transition: background 0.3s var(--mh-ease), border-color 0.3s var(--mh-ease);
}

.mh-nav--solid {
  background: rgba(255, 255, 255, 0.94);
  border-bottom-color: var(--mh-line);
  box-shadow: 0 4px 20px rgba(11, 31, 51, 0.04);
}

.mh-nav__inner {
  width: min(1120px, calc(100% - 32px));
  margin: 0 auto;
  min-height: 72px;
  display: flex;
  align-items: center;
  gap: 20px;
}

.mh-nav__brand img {
  height: 36px;
  width: auto;
  display: block;
}

.mh-nav__links {
  display: flex;
  gap: 20px;
  flex: 1 1;
  justify-content: center;
}

.mh-nav__links a {
  color: var(--mh-navy);
  text-decoration: none;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.01em;
  transition: color 0.2s ease;
}

.mh-nav__links a:hover {
  color: var(--mh-blue);
}

.mh-nav__actions {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
  flex-shrink: 0;
}

.mh-nav__brand {
  flex-shrink: 0;
}

.mh-lang select {
  appearance: none;
  border: 1px solid var(--mh-line);
  background: var(--mh-white);
  color: var(--mh-navy);
  border-radius: 999px;
  padding: 8px 28px 8px 12px;
  font: inherit;
  font-size: 13px;
  cursor: pointer;
}

.mh-lang--drawer {
  display: none;
  margin-bottom: 16px;
}

.mh-lang--drawer select {
  width: 100%;
}

.mh-nav__auth {
  white-space: nowrap;
}

.mh-nav__pilot {
  white-space: nowrap;
}

/* Mobile Hamburger Button */
.mh-nav__burger {
  display: none;
  background: transparent;
  border: 0;
  padding: 8px;
  cursor: pointer;
  align-items: center;
  justify-content: center;
}

.mh-nav__burger-icon {
  display: block;
  width: 22px;
  height: 2px;
  background: var(--mh-navy);
  position: relative;
  transition: background 0.2s ease;
}

.mh-nav__burger-icon::before,
.mh-nav__burger-icon::after {
  content: "";
  position: absolute;
  left: 0;
  width: 22px;
  height: 2px;
  background: var(--mh-navy);
  transition: transform 0.25s ease;
}

.mh-nav__burger-icon::before {
  top: -7px;
}

.mh-nav__burger-icon::after {
  bottom: -7px;
}

.mh-nav__burger-icon.is-open {
  background: transparent;
}

.mh-nav__burger-icon.is-open::before {
  transform: translateY(7px) rotate(45deg);
}

.mh-nav__burger-icon.is-open::after {
  transform: translateY(-7px) rotate(-45deg);
}

/* Mobile Drawer Overlay */
.mh-nav__mobile-drawer {
  background: var(--mh-white);
  border-bottom: 1px solid var(--mh-line);
  padding: 20px 24px 28px;
  box-shadow: 0 16px 32px rgba(11, 31, 51, 0.08);
  animation: mhSlideDown 0.25s var(--mh-ease);
}

@keyframes mhSlideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.mh-nav__mobile-links {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 24px;
}

.mh-nav__mobile-links a {
  color: var(--mh-navy);
  font-size: 16px;
  font-weight: 600;
  text-decoration: none;
}

.mh-nav__mobile-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.mh-nav__mobile-actions .mh-btn {
  flex: 1 1 auto;
  min-width: 120px;
}

/* ==========================================================================
   BUTTONS & CTAS
   ========================================================================== */

.mh-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  border: 0;
  cursor: pointer;
  font: inherit;
  font-weight: 600;
  font-size: 14px;
  border-radius: 999px;
  padding: 10px 18px;
  transition: transform 0.3s var(--mh-ease), background 0.3s var(--mh-ease), box-shadow 0.3s var(--mh-ease);
  min-height: 42px;
}

.mh-btn:hover {
  transform: scale(1.02);
}

.mh-btn:active {
  transform: scale(0.98);
}

.mh-btn--primary {
  background: var(--mh-blue);
  color: #fff;
  box-shadow: 0 4px 14px rgba(8, 119, 188, 0.25);
}

.mh-btn--primary:hover {
  background: var(--mh-blue-dark);
  box-shadow: 0 6px 20px rgba(8, 119, 188, 0.35);
}

.mh-btn--ghost {
  background: transparent;
  color: var(--mh-navy);
  border: 1px solid var(--mh-line);
}

.mh-btn--sm {
  padding: 8px 14px;
  font-size: 13px;
  min-height: 36px;
}

/* ==========================================================================
   HERO SECTION
   ========================================================================== */

.mh-hero {
  display: grid;
  grid-template-columns: 1.05fr 0.95fr;
  gap: clamp(32px, 5vw, 72px);
  align-items: center;
  padding: 56px 0 72px;
}

.mh-eyebrow {
  margin: 0 0 12px;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--mh-blue);
}

.mh-hero h1 {
  margin: 0 0 16px;
  font-size: clamp(34px, 5vw, 64px);
  line-height: 1.05;
  letter-spacing: -0.03em;
  color: var(--mh-navy);
}

.mh-lead {
  margin: 0 0 20px;
  font-size: 18px;
  line-height: 1.55;
  color: var(--mh-muted);
}

.mh-hero__ctas {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 16px;
}

.mh-micro {
  margin: 0;
  font-size: 13px;
  color: var(--mh-muted);
}

.mh-chip {
  display: inline-block;
  margin-top: 14px;
  background: var(--mh-peach);
  color: var(--mh-navy);
  border-radius: 999px;
  padding: 6px 14px;
  font-size: 12px;
  font-weight: 600;
}

/* ==========================================================================
   LIVE HALL SIMULATION MOCKUP
   ========================================================================== */

.mh-hall {
  position: relative;
  border-radius: 24px;
  overflow: hidden;
  min-height: 400px;
  background: var(--mh-navy);
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 20px 48px -12px rgba(11, 31, 51, 0.35);
}

.mh-hall__plate {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: 0.22;
}

.mh-hall__mock {
  position: relative;
  margin: 20px 18px;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.4);
  border-radius: 20px;
  padding: 18px;
}

.mh-hall__bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 14px;
}

.mh-hall__live-tag {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: var(--mh-navy);
}

.mh-hall__beacon {
  width: 10px;
  height: 10px;
  background: #10b981;
  border-radius: 50%;
  display: inline-block;
  box-shadow: 0 0 0 0 rgba(16, 185, 129, 0.7);
  animation: mhPulse 2s infinite;
}

@keyframes mhPulse {
  0% {
    box-shadow: 0 0 0 0 rgba(16, 185, 129, 0.7);
  }
  70% {
    box-shadow: 0 0 0 8px rgba(16, 185, 129, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(16, 185, 129, 0);
  }
}

.mh-hall__mode-chip {
  font-size: 11px;
  font-weight: 600;
  background: var(--mh-hall);
  border: 1px solid var(--mh-line);
  padding: 4px 8px;
  border-radius: 999px;
  color: var(--mh-muted);
}

.mh-hall__grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}

.mh-table {
  border: 1px solid var(--mh-line);
  border-radius: 14px;
  padding: 10px 12px;
  background: var(--mh-white);
  cursor: pointer;
  transition: transform 0.2s var(--mh-ease), box-shadow 0.2s var(--mh-ease), border-color 0.2s var(--mh-ease);
  border-left: 3px solid var(--table-accent, var(--mh-blue));
}

.mh-table:hover,
.mh-table.is-focused {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(11, 31, 51, 0.08);
  border-color: var(--table-accent, var(--mh-blue));
}

.mh-table__top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 4px;
}

.mh-table__top strong {
  font-size: 12px;
  color: var(--mh-navy);
}

.mh-table__agent-tag {
  font-size: 11px;
  font-weight: 700;
}

.mh-table__ex {
  margin: 0 0 6px;
  font-size: 11px;
  color: var(--mh-muted);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.mh-table__hr-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.mh-table__hr-val {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  font-weight: 600;
  color: var(--mh-navy);
}

.mh-table__pulse-dot {
  width: 6px;
  height: 6px;
  background: #ef4444;
  border-radius: 50%;
  display: inline-block;
}

.mh-table__zone {
  font-size: 10px;
  background: var(--mh-hall);
  border-radius: 4px;
  padding: 2px 6px;
  color: var(--mh-muted);
}

.mh-hall__coach-hud {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 14px;
  padding-top: 10px;
  border-top: 1px solid var(--mh-line);
}

.mh-hall__coach-badge {
  font-size: 11px;
  font-weight: 700;
  color: var(--mh-blue);
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.mh-hall__subtext {
  font-size: 11px;
  color: var(--mh-muted);
}

/* ==========================================================================
   PROOF TICKER
   ========================================================================== */

.mh-proof {
  display: flex;
  flex-wrap: wrap;
  gap: 10px 24px;
  padding: 12px 0 48px;
  border-bottom: 1px solid var(--mh-line);
}

.mh-proof span {
  font-size: 13px;
  font-weight: 600;
  color: var(--mh-navy);
}

/* ==========================================================================
   SECTIONS & GRIDS
   ========================================================================== */

.mh-section {
  padding: 80px 0;
}

.mh-section--navy {
  background: var(--mh-navy);
  color: #f4f7fb;
}

.mh-section--navy .mh-eyebrow {
  color: #9fd4f0;
}

.mh-section--navy h2,
.mh-section--navy h3 {
  color: #fff;
}

.mh-section--navy .mh-lead,
.mh-section--navy > .mh-wrap > p,
.mh-section--navy .mh-note {
  color: rgba(244, 247, 251, 0.82);
}

.mh-section--navy .mh-card h3 {
  color: var(--mh-navy);
}

.mh-section--navy .mh-card p {
  color: var(--mh-muted);
}

.mh-section h2 {
  margin: 0 0 16px;
  font-size: clamp(28px, 3.2vw, 40px);
  letter-spacing: -0.03em;
  line-height: 1.15;
  color: var(--mh-navy);
}

.mh-grid-2 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 36px;
  align-items: start;
}

/* Problem Section Breakdown */
.mh-problem-cards {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 24px;
}

.mh-problem-card {
  background: var(--mh-white);
  border: 1px solid var(--mh-line);
  border-radius: 14px;
  padding: 16px 20px;
}

.mh-problem-card strong {
  display: block;
  font-size: 15px;
  margin-bottom: 4px;
  color: var(--mh-navy);
}

.mh-problem-card p {
  margin: 0;
  font-size: 14px;
  line-height: 1.5;
  color: var(--mh-muted);
}

.mh-problem-card--stt {
  border-color: rgba(8, 119, 188, 0.35);
  background: rgba(8, 119, 188, 0.04);
}

.mh-problem-card--stt strong {
  color: var(--mh-blue);
}

/* The 4 Beats (How it works) */
.mh-beats {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 18px;
  margin-top: 32px;
}

.mh-beat {
  background: var(--mh-white);
  border-radius: 16px;
  padding: 22px;
  border: 1px solid var(--mh-line);
}

.mh-beat__n {
  font-size: 12px;
  font-weight: 700;
  color: var(--mh-blue);
  letter-spacing: 0.08em;
}

.mh-beat h3,
.mh-card h3 {
  margin: 10px 0 8px;
  font-size: 18px;
  color: var(--mh-navy);
}

.mh-beat p,
.mh-card p {
  margin: 0;
  font-size: 14px;
  line-height: 1.55;
  color: var(--mh-muted);
}

.mh-cards-3 {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 18px;
  margin-top: 28px;
}

.mh-card {
  background: var(--mh-white);
  border-radius: 16px;
  padding: 24px;
  border: 1px solid var(--mh-line);
  transition: transform 0.35s var(--mh-ease);
}

.mh-card:hover {
  transform: translateY(-3px);
}

.mh-note {
  margin: 20px 0 0;
  font-size: 14px;
  color: var(--mh-muted);
}

.mh-roles {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 18px;
  margin-top: 28px;
}

/* ==========================================================================
   THE FOUR FLOWS
   ========================================================================== */

.mh-flow-board {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  margin-top: 28px;
}

.mh-flow-card {
  display: flex;
  flex-direction: column;
  gap: 12px;
  text-decoration: none;
  color: inherit;
  background: var(--mh-white);
  border-radius: 20px;
  padding: 24px;
  border: 1px solid var(--mh-line);
  border-top: 4px solid var(--flow-accent, var(--mh-blue));
  transition: transform 0.3s var(--mh-ease), box-shadow 0.3s var(--mh-ease);
}

.mh-flow-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 28px rgba(11, 31, 51, 0.08);
}

.mh-flow-card__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.mh-flow-card h3 {
  margin: 0;
  font-size: 24px;
  color: var(--mh-navy);
}

.mh-flow-card__badge {
  font-size: 11px;
  font-weight: 700;
  background: var(--mh-hall);
  border: 1px solid var(--mh-line);
  border-radius: 999px;
  padding: 3px 10px;
  color: var(--mh-navy);
}

.mh-flow-card__mission {
  margin: 0;
  font-size: 14px;
  line-height: 1.5;
  color: var(--mh-muted);
}

.mh-flow-card__commitment {
  background: rgba(11, 31, 51, 0.06);
  border-radius: 8px;
  padding: 6px 10px;
  font-size: 12px;
  color: var(--mh-navy);
}

.mh-kws {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.mh-kws li {
  font-size: 12px;
  background: var(--mh-hall);
  border-radius: 999px;
  padding: 4px 10px;
  color: var(--mh-navy);
}

.mh-flow-link {
  margin-top: auto;
  font-size: 14px;
  font-weight: 700;
  color: var(--flow-accent, var(--mh-blue));
}

.mh-fork {
  margin-top: 24px;
  font-size: 14px;
  color: var(--mh-muted);
}

/* ==========================================================================
   SCFORH & ONE HEALTH SHOWCASE
   ========================================================================== */

.mh-scforh-pillars {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  margin: 32px 0;
}

.mh-scforh-pillar {
  background: var(--mh-white);
  border: 1px solid var(--mh-line);
  border-radius: 18px;
  padding: 24px;
  transition: transform 0.3s var(--mh-ease);
}

.mh-scforh-pillar:hover {
  transform: translateY(-3px);
}

.mh-scforh-pillar__icon {
  font-size: 32px;
  margin-bottom: 12px;
}

.mh-scforh-pillar h3 {
  margin: 0 0 8px;
  font-size: 18px;
  color: var(--mh-navy);
}

.mh-scforh-pillar p {
  margin: 0;
  font-size: 14px;
  line-height: 1.55;
  color: var(--mh-muted);
}

.mh-scforh-principles {
  background: var(--mh-white);
  border: 1px solid var(--mh-line);
  border-radius: 18px;
  padding: 24px;
  margin-bottom: 28px;
}

.mh-scforh-principles h3 {
  margin: 0 0 16px;
  font-size: 17px;
  color: var(--mh-navy);
}

.mh-scforh-principles__grid {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.mh-scforh-tag {
  font-size: 13px;
  background: rgba(15, 123, 108, 0.08);
  border: 1px solid rgba(15, 123, 108, 0.2);
  color: var(--mh-sage);
  border-radius: 999px;
  padding: 6px 14px;
  font-weight: 500;
}

/* SmartTTClub Breakdown: SMART + TT + Club (One Health) */
.mh-brand-meaning {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  margin: 20px 0 28px;
}

.mh-brand-meaning__card {
  background: var(--mh-white);
  border: 1px solid var(--mh-line);
  border-radius: 18px;
  padding: 22px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.mh-brand-meaning__card--onehealth {
  border-color: rgba(15, 123, 108, 0.3);
  background: rgba(15, 123, 108, 0.03);
}

.mh-brand-meaning__tag {
  align-self: flex-start;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  background: var(--mh-hall);
  border: 1px solid var(--mh-line);
  color: var(--mh-blue);
  padding: 4px 10px;
  border-radius: 999px;
}

.mh-brand-meaning__tag--onehealth {
  background: rgba(15, 123, 108, 0.1);
  color: var(--mh-sage);
  border-color: rgba(15, 123, 108, 0.25);
}

.mh-brand-meaning__card h4 {
  margin: 0;
  font-size: 16px;
  color: var(--mh-navy);
}

.mh-brand-meaning__card p {
  margin: 0;
  font-size: 13px;
  line-height: 1.55;
  color: var(--mh-muted);
}

/* S.M.A.R.T. 5-Letter Cards */
.mh-smart {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 14px;
  margin-top: 24px;
}

.mh-smart article {
  background: var(--mh-white);
  border: 1px solid var(--mh-line);
  border-radius: 16px;
  padding: 18px;
}

.mh-smart h3 {
  margin: 0 0 8px;
  font-size: 16px;
  color: var(--mh-navy);
}

.mh-smart p {
  margin: 0;
  font-size: 13px;
  line-height: 1.5;
  color: var(--mh-muted);
}

/* ==========================================================================
   PILOT INQUIRY FORM & SPLIT
   ========================================================================== */

.mh-pilot-split {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 40px;
  align-items: start;
}

.mh-dl {
  margin: 0;
}

.mh-dl dt {
  margin-top: 18px;
  font-weight: 700;
  color: var(--mh-navy);
}

.mh-dl dd {
  margin: 6px 0 0;
  color: var(--mh-muted);
  line-height: 1.55;
  font-size: 15px;
}

.mh-form {
  background: var(--mh-white);
  border: 1px solid var(--mh-line);
  border-radius: 20px;
  padding: 26px;
  display: grid;
  gap: 14px;
  box-shadow: 0 8px 24px rgba(11, 31, 51, 0.04);
}

.mh-form__row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.mh-form label {
  display: grid;
  gap: 6px;
  font-size: 13px;
  font-weight: 600;
  color: var(--mh-navy);
}

.mh-form input,
.mh-form select,
.mh-form textarea {
  font: inherit;
  font-weight: 400;
  border: 1px solid var(--mh-line);
  border-radius: 12px;
  padding: 10px 14px;
  background: var(--mh-hall);
  color: var(--mh-ink);
}

.mh-form__error {
  margin: 0;
  color: #9b1c1c;
  font-size: 14px;
}

.mh-form__thanks {
  background: var(--mh-peach);
  border-radius: 16px;
  padding: 24px;
  color: var(--mh-navy);
  line-height: 1.55;
}

/* ==========================================================================
   FAQ & CTA
   ========================================================================== */

.mh-faq details {
  border-bottom: 1px solid var(--mh-line);
  padding: 16px 0;
}

.mh-faq summary {
  cursor: pointer;
  font-weight: 600;
  color: var(--mh-navy);
  font-size: 16px;
}

.mh-faq p {
  margin: 12px 0 0;
  color: var(--mh-muted);
  line-height: 1.6;
  font-size: 15px;
}

.mh-cta {
  text-align: center;
  padding: 80px 0 48px;
}

.mh-cta h2 {
  margin-bottom: 12px;
}

/* ==========================================================================
   FOOTER
   ========================================================================== */

.mh-footer {
  background: var(--mh-navy);
  color: rgba(244, 247, 251, 0.8);
  padding: 48px 0;
}

.mh-footer__grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 28px;
}

.mh-footer__logo {
  height: 32px;
  width: auto;
  filter: brightness(0) invert(1);
}

.mh-footer__tag {
  margin: 14px 0 0;
  max-width: 38ch;
  line-height: 1.5;
  font-size: 14px;
}

.mh-footer a {
  color: #9fd4f0;
}

.mh-footer .mh-legal,
.mh-footer .legal-footer {
  margin-top: 14px;
  justify-content: flex-start;
  color: rgba(244, 247, 251, 0.75);
}

.mh-footer .mh-legal a,
.mh-footer .legal-footer a {
  color: #9fd4f0;
}

/* ==========================================================================
   FLOW STORY PAGE
   ========================================================================== */

.mh-flow-page {
  padding: 48px 0 80px;
}

.mh-flow-page__mark {
  width: 52px;
  height: 8px;
  border-radius: 999px;
  background: var(--flow-accent, var(--mh-blue));
  margin-bottom: 16px;
}

.mh-pro-commitment-banner {
  background: rgba(11, 31, 51, 0.06);
  border-left: 4px solid var(--mh-navy);
  padding: 12px 18px;
  border-radius: 8px;
  margin: 20px 0;
  color: var(--mh-navy);
}

.mh-flow-story-body p {
  font-size: 17px;
  line-height: 1.7;
  color: var(--mh-muted);
}

.mh-flow-detail-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  margin-top: 32px;
}

.mh-flow-detail-card {
  background: var(--mh-white);
  border: 1px solid var(--mh-line);
  border-radius: 16px;
  padding: 22px;
}

.mh-flow-detail-card p {
  margin: 0;
  font-size: 15px;
  line-height: 1.55;
  color: var(--mh-muted);
}

.mh-flow-others {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 28px;
}

/* ==========================================================================
   MOBILE FLOATING STICKY ACTION BAR
   ========================================================================== */

.mh-mobile-sticky-bar {
  display: none;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 60;
  background: rgba(255, 255, 255, 0.94);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  border-top: 1px solid var(--mh-line);
  padding: 10px 18px;
  box-shadow: 0 -4px 16px rgba(11, 31, 51, 0.08);
}

.mh-mobile-sticky-bar__inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.mh-mobile-sticky-bar__text {
  font-size: 13px;
  font-weight: 700;
  color: var(--mh-navy);
}

/* ==========================================================================
   RESPONSIVE MEDIA QUERIES (Mobile & Tablet)
   ========================================================================== */

@media (max-width: 960px) {
  .mh-nav__links {
    display: none;
  }

  .mh-nav__burger {
    display: inline-flex;
  }

  /* Keep Sign in / Sign up in the top bar; pilot lives in the drawer + sticky bar */
  .mh-nav__pilot {
    display: none;
  }

  .mh-nav__inner {
    width: min(1120px, calc(100% - 24px));
    min-height: 64px;
    gap: 12px;
  }

  .mh-nav__brand img {
    height: 30px;
  }

  .mh-nav__actions {
    gap: 6px;
  }

  .mh-hero,
  .mh-grid-2,
  .mh-pilot-split,
  .mh-footer__grid {
    grid-template-columns: 1fr;
  }

  .mh-beats,
  .mh-cards-3,
  .mh-roles,
  .mh-smart,
  .mh-brand-meaning,
  .mh-flow-board,
  .mh-scforh-pillars,
  .mh-flow-detail-grid {
    grid-template-columns: 1fr;
  }

  .mh-hero {
    padding-top: 32px;
  }

  .mh-hall {
    min-height: 340px;
  }

  .mh-hall__mock {
    margin: 14px 12px;
    padding: 14px;
  }

  .mh-hall__grid {
    grid-template-columns: 1fr;
  }

  .mh-mobile-sticky-bar {
    display: block;
  }

  main {
    padding-bottom: 50px;
  }
}

@media (max-width: 640px) {
  .mh-form__row {
    grid-template-columns: 1fr;
  }

  /* Language moves into the drawer so auth CTAs stay visible top-right */
  .mh-lang--bar {
    display: none;
  }

  .mh-lang--drawer {
    display: block;
  }

  .mh-nav__actions .mh-nav__auth {
    padding: 7px 12px;
    font-size: 12px;
    min-height: 34px;
  }

  .mh-wrap {
    width: min(1120px, calc(100% - 28px));
  }

  .mh-hero h1 {
    font-size: 32px;
  }

  .mh-hero__ctas {
    flex-direction: column;
  }

  .mh-hero__ctas .mh-btn,
  .mh-cta .mh-btn,
  .mh-section .mh-btn,
  .mh-nav__mobile-actions .mh-btn {
    width: 100%;
  }

  .mh-nav__actions .mh-btn {
    width: auto;
  }

  .mh-mobile-sticky-bar .mh-btn {
    width: auto;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/public/MarketingHome.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,wCAAwC;EACxC,oBAAoB;EACpB,0BAA0B;EAC1B,+EAA+E;EAC/E,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,iBAAiB;EACjB,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;;EAGE,uBAAuB;AACzB;;AAEA;EACE;;;IAGE,uBAAuB;EACzB;AACF;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;;+EAE+E;;AAE/E;EACE,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,qCAAqC;EACrC,2BAA2B;EAC3B,mCAAmC;EACnC,oCAAoC;EACpC,4EAA4E;AAC9E;;AAEA;EACE,qCAAqC;EACrC,mCAAmC;EACnC,6CAA6C;AAC/C;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,SAAO;EACP,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,2BAA2B;EAC3B,qBAAqB;EACrB,oBAAoB;EACpB,0BAA0B;EAC1B,aAAa;EACb,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,0BAA0B;EAC1B,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,WAAW;EACX,WAAW;EACX,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA,0BAA0B;AAC1B;EACE,2BAA2B;EAC3B,uCAAuC;EACvC,uBAAuB;EACvB,8CAA8C;EAC9C,2CAA2C;AAC7C;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;+EAE+E;;AAE/E;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,SAAS;EACT,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,yGAAyG;EACzG,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,WAAW;EACX,8CAA8C;AAChD;;AAEA;EACE,+BAA+B;EAC/B,8CAA8C;AAChD;;AAEA;EACE,uBAAuB;EACvB,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;+EAE+E;;AAE/E;EACE,aAAa;EACb,oCAAoC;EACpC,2BAA2B;EAC3B,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;EACjC,iBAAiB;EACjB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,2BAA2B;EAC3B,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;+EAE+E;;AAE/E;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;EAC1B,wFAAwF;AAC1F;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,qCAAqC;EACrC,2BAA2B;EAC3B,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,2CAA2C;EAC3C,8BAA8B;AAChC;;AAEA;EACE;IACE,2CAA2C;EAC7C;EACA;IACE,2CAA2C;EAC7C;EACA;IACE,yCAAyC;EAC3C;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,gCAAgC;EAChC,gBAAgB;EAChB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;EACnB,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;EACf,2GAA2G;EAC3G,0DAA0D;AAC5D;;AAEA;;EAEE,2BAA2B;EAC3B,6CAA6C;EAC7C,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,iBAAiB;EACjB,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA;;+EAE+E;;AAE/E;EACE,aAAa;EACb,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,uCAAuC;AACzC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;;+EAE+E;;AAE/E;EACE,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,WAAW;AACb;;AAEA;;;EAGE,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,mCAAmC;EACnC,uBAAuB;EACvB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,gCAAgC;EAChC,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,qCAAqC;EACrC,mCAAmC;AACrC;;AAEA;EACE,qBAAqB;AACvB;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;;EAEE,kBAAkB;EAClB,eAAe;EACf,qBAAqB;AACvB;;AAEA;;EAEE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,gCAAgC;EAChC,0CAA0C;AAC5C;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,gBAAgB;AAClB;;AAEA;;+EAE+E;;AAE/E;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,qBAAqB;EACrB,cAAc;EACd,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,gCAAgC;EAChC,wDAAwD;EACxD,yEAAyE;AAC3E;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,gCAAgC;EAChC,oBAAoB;EACpB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,oBAAoB;EACpB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,sBAAsB;AACxB;;AAEA;;+EAE+E;;AAE/E;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,gCAAgC;EAChC,mBAAmB;EACnB,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,gCAAgC;EAChC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,oCAAoC;EACpC,yCAAyC;EACzC,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,0DAA0D;AAC1D;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,gCAAgC;EAChC,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,qCAAqC;EACrC,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,0BAA0B;EAC1B,gCAAgC;EAChC,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,mCAAmC;EACnC,qBAAqB;EACrB,sCAAsC;AACxC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,gCAAgC;EAChC,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;;+EAE+E;;AAE/E;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,gCAAgC;EAChC,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,SAAS;EACT,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;;;EAGE,aAAa;EACb,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;EACnB,kBAAkB;EAClB,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;;+EAE+E;;AAE/E;EACE,uCAAuC;EACvC,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;+EAE+E;;AAE/E;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,gBAAgB;EAChB,2BAA2B;EAC3B,gCAAgC;AAClC;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;+EAE+E;;AAE/E;EACE,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,oBAAoB;EACpB,8CAA8C;EAC9C,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,qCAAqC;EACrC,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,gCAAgC;EAChC,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA;;+EAE+E;;AAE/E;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,OAAO;EACP,QAAQ;EACR,WAAW;EACX,qCAAqC;EACrC,2BAA2B;EAC3B,mCAAmC;EACnC,oCAAoC;EACpC,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;;+EAE+E;;AAE/E;EACE;IACE,aAAa;EACf;;EAEA;IACE,oBAAoB;EACtB;;EAEA,kFAAkF;EAClF;IACE,aAAa;EACf;;EAEA;IACE,qCAAqC;IACrC,gBAAgB;IAChB,SAAS;EACX;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,QAAQ;EACV;;EAEA;;;;IAIE,0BAA0B;EAC5B;;EAEA;;;;;;;;IAQE,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA,uEAAuE;EACvE;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;;;IAIE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":[".mh {\n  --mh-navy: #0b1f33;\n  --mh-ink: #1e1e1e;\n  --mh-muted: #5c6570;\n  --mh-hall: #f7f8fa;\n  --mh-white: #ffffff;\n  --mh-blue: #0877bc;\n  --mh-blue-dark: #065a8f;\n  --mh-peach: #ffefdd;\n  --mh-sage: #0f7b6c;\n  --mh-line: rgba(11, 31, 51, 0.1);\n  --mh-ease: cubic-bezier(0.25, 1, 0.5, 1);\n  color: var(--mh-ink);\n  background: var(--mh-hall);\n  font-family: Poppins, -apple-system, BlinkMacSystemFont, \"Segoe UI\", sans-serif;\n  min-height: 100dvh;\n  overflow-x: hidden;\n}\n\n.mh-sr,\n.mh-skip {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n.mh-skip:focus {\n  position: fixed;\n  top: 8px;\n  left: 8px;\n  z-index: 80;\n  width: auto;\n  height: auto;\n  clip: auto;\n  margin: 0;\n  padding: 8px 12px;\n  background: var(--mh-white);\n  color: var(--mh-navy);\n}\n\n.mh :focus-visible {\n  outline: 2px solid var(--mh-blue);\n  outline-offset: 3px;\n}\n\nhtml {\n  scroll-behavior: smooth;\n}\n\n.mh-section,\n.mh-hero,\n[id] {\n  scroll-margin-top: 92px;\n}\n\n@media (max-width: 960px) {\n  .mh-section,\n  .mh-hero,\n  [id] {\n    scroll-margin-top: 84px;\n  }\n}\n\n.mh-wrap {\n  width: min(1120px, calc(100% - 40px));\n  margin: 0 auto;\n}\n\n/* ==========================================================================\n   NAVIGATION\n   ========================================================================== */\n\n.mh-nav {\n  position: sticky;\n  top: 0;\n  z-index: 50;\n  background: rgba(247, 248, 250, 0.78);\n  backdrop-filter: blur(16px);\n  -webkit-backdrop-filter: blur(16px);\n  border-bottom: 1px solid transparent;\n  transition: background 0.3s var(--mh-ease), border-color 0.3s var(--mh-ease);\n}\n\n.mh-nav--solid {\n  background: rgba(255, 255, 255, 0.94);\n  border-bottom-color: var(--mh-line);\n  box-shadow: 0 4px 20px rgba(11, 31, 51, 0.04);\n}\n\n.mh-nav__inner {\n  width: min(1120px, calc(100% - 32px));\n  margin: 0 auto;\n  min-height: 72px;\n  display: flex;\n  align-items: center;\n  gap: 20px;\n}\n\n.mh-nav__brand img {\n  height: 36px;\n  width: auto;\n  display: block;\n}\n\n.mh-nav__links {\n  display: flex;\n  gap: 20px;\n  flex: 1;\n  justify-content: center;\n}\n\n.mh-nav__links a {\n  color: var(--mh-navy);\n  text-decoration: none;\n  font-size: 14px;\n  font-weight: 500;\n  letter-spacing: 0.01em;\n  transition: color 0.2s ease;\n}\n\n.mh-nav__links a:hover {\n  color: var(--mh-blue);\n}\n\n.mh-nav__actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-left: auto;\n  flex-shrink: 0;\n}\n\n.mh-nav__brand {\n  flex-shrink: 0;\n}\n\n.mh-lang select {\n  appearance: none;\n  border: 1px solid var(--mh-line);\n  background: var(--mh-white);\n  color: var(--mh-navy);\n  border-radius: 999px;\n  padding: 8px 28px 8px 12px;\n  font: inherit;\n  font-size: 13px;\n  cursor: pointer;\n}\n\n.mh-lang--drawer {\n  display: none;\n  margin-bottom: 16px;\n}\n\n.mh-lang--drawer select {\n  width: 100%;\n}\n\n.mh-nav__auth {\n  white-space: nowrap;\n}\n\n.mh-nav__pilot {\n  white-space: nowrap;\n}\n\n/* Mobile Hamburger Button */\n.mh-nav__burger {\n  display: none;\n  background: transparent;\n  border: 0;\n  padding: 8px;\n  cursor: pointer;\n  align-items: center;\n  justify-content: center;\n}\n\n.mh-nav__burger-icon {\n  display: block;\n  width: 22px;\n  height: 2px;\n  background: var(--mh-navy);\n  position: relative;\n  transition: background 0.2s ease;\n}\n\n.mh-nav__burger-icon::before,\n.mh-nav__burger-icon::after {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  width: 22px;\n  height: 2px;\n  background: var(--mh-navy);\n  transition: transform 0.25s ease;\n}\n\n.mh-nav__burger-icon::before {\n  top: -7px;\n}\n\n.mh-nav__burger-icon::after {\n  bottom: -7px;\n}\n\n.mh-nav__burger-icon.is-open {\n  background: transparent;\n}\n\n.mh-nav__burger-icon.is-open::before {\n  transform: translateY(7px) rotate(45deg);\n}\n\n.mh-nav__burger-icon.is-open::after {\n  transform: translateY(-7px) rotate(-45deg);\n}\n\n/* Mobile Drawer Overlay */\n.mh-nav__mobile-drawer {\n  background: var(--mh-white);\n  border-bottom: 1px solid var(--mh-line);\n  padding: 20px 24px 28px;\n  box-shadow: 0 16px 32px rgba(11, 31, 51, 0.08);\n  animation: mhSlideDown 0.25s var(--mh-ease);\n}\n\n@keyframes mhSlideDown {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.mh-nav__mobile-links {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  margin-bottom: 24px;\n}\n\n.mh-nav__mobile-links a {\n  color: var(--mh-navy);\n  font-size: 16px;\n  font-weight: 600;\n  text-decoration: none;\n}\n\n.mh-nav__mobile-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n}\n\n.mh-nav__mobile-actions .mh-btn {\n  flex: 1 1 auto;\n  min-width: 120px;\n}\n\n/* ==========================================================================\n   BUTTONS & CTAS\n   ========================================================================== */\n\n.mh-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  text-decoration: none;\n  border: 0;\n  cursor: pointer;\n  font: inherit;\n  font-weight: 600;\n  font-size: 14px;\n  border-radius: 999px;\n  padding: 10px 18px;\n  transition: transform 0.3s var(--mh-ease), background 0.3s var(--mh-ease), box-shadow 0.3s var(--mh-ease);\n  min-height: 42px;\n}\n\n.mh-btn:hover {\n  transform: scale(1.02);\n}\n\n.mh-btn:active {\n  transform: scale(0.98);\n}\n\n.mh-btn--primary {\n  background: var(--mh-blue);\n  color: #fff;\n  box-shadow: 0 4px 14px rgba(8, 119, 188, 0.25);\n}\n\n.mh-btn--primary:hover {\n  background: var(--mh-blue-dark);\n  box-shadow: 0 6px 20px rgba(8, 119, 188, 0.35);\n}\n\n.mh-btn--ghost {\n  background: transparent;\n  color: var(--mh-navy);\n  border: 1px solid var(--mh-line);\n}\n\n.mh-btn--sm {\n  padding: 8px 14px;\n  font-size: 13px;\n  min-height: 36px;\n}\n\n/* ==========================================================================\n   HERO SECTION\n   ========================================================================== */\n\n.mh-hero {\n  display: grid;\n  grid-template-columns: 1.05fr 0.95fr;\n  gap: clamp(32px, 5vw, 72px);\n  align-items: center;\n  padding: 56px 0 72px;\n}\n\n.mh-eyebrow {\n  margin: 0 0 12px;\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: var(--mh-blue);\n}\n\n.mh-hero h1 {\n  margin: 0 0 16px;\n  font-size: clamp(34px, 5vw, 64px);\n  line-height: 1.05;\n  letter-spacing: -0.03em;\n  color: var(--mh-navy);\n}\n\n.mh-lead {\n  margin: 0 0 20px;\n  font-size: 18px;\n  line-height: 1.55;\n  color: var(--mh-muted);\n}\n\n.mh-hero__ctas {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  margin-bottom: 16px;\n}\n\n.mh-micro {\n  margin: 0;\n  font-size: 13px;\n  color: var(--mh-muted);\n}\n\n.mh-chip {\n  display: inline-block;\n  margin-top: 14px;\n  background: var(--mh-peach);\n  color: var(--mh-navy);\n  border-radius: 999px;\n  padding: 6px 14px;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n/* ==========================================================================\n   LIVE HALL SIMULATION MOCKUP\n   ========================================================================== */\n\n.mh-hall {\n  position: relative;\n  border-radius: 24px;\n  overflow: hidden;\n  min-height: 400px;\n  background: var(--mh-navy);\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 20px 48px -12px rgba(11, 31, 51, 0.35);\n}\n\n.mh-hall__plate {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  opacity: 0.22;\n}\n\n.mh-hall__mock {\n  position: relative;\n  margin: 20px 18px;\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(12px);\n  border: 1px solid rgba(255, 255, 255, 0.4);\n  border-radius: 20px;\n  padding: 18px;\n}\n\n.mh-hall__bar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 14px;\n}\n\n.mh-hall__live-tag {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 13px;\n  color: var(--mh-navy);\n}\n\n.mh-hall__beacon {\n  width: 10px;\n  height: 10px;\n  background: #10b981;\n  border-radius: 50%;\n  display: inline-block;\n  box-shadow: 0 0 0 0 rgba(16, 185, 129, 0.7);\n  animation: mhPulse 2s infinite;\n}\n\n@keyframes mhPulse {\n  0% {\n    box-shadow: 0 0 0 0 rgba(16, 185, 129, 0.7);\n  }\n  70% {\n    box-shadow: 0 0 0 8px rgba(16, 185, 129, 0);\n  }\n  100% {\n    box-shadow: 0 0 0 0 rgba(16, 185, 129, 0);\n  }\n}\n\n.mh-hall__mode-chip {\n  font-size: 11px;\n  font-weight: 600;\n  background: var(--mh-hall);\n  border: 1px solid var(--mh-line);\n  padding: 4px 8px;\n  border-radius: 999px;\n  color: var(--mh-muted);\n}\n\n.mh-hall__grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 10px;\n}\n\n.mh-table {\n  border: 1px solid var(--mh-line);\n  border-radius: 14px;\n  padding: 10px 12px;\n  background: var(--mh-white);\n  cursor: pointer;\n  transition: transform 0.2s var(--mh-ease), box-shadow 0.2s var(--mh-ease), border-color 0.2s var(--mh-ease);\n  border-left: 3px solid var(--table-accent, var(--mh-blue));\n}\n\n.mh-table:hover,\n.mh-table.is-focused {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 16px rgba(11, 31, 51, 0.08);\n  border-color: var(--table-accent, var(--mh-blue));\n}\n\n.mh-table__top {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 4px;\n}\n\n.mh-table__top strong {\n  font-size: 12px;\n  color: var(--mh-navy);\n}\n\n.mh-table__agent-tag {\n  font-size: 11px;\n  font-weight: 700;\n}\n\n.mh-table__ex {\n  margin: 0 0 6px;\n  font-size: 11px;\n  color: var(--mh-muted);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.mh-table__hr-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.mh-table__hr-val {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--mh-navy);\n}\n\n.mh-table__pulse-dot {\n  width: 6px;\n  height: 6px;\n  background: #ef4444;\n  border-radius: 50%;\n  display: inline-block;\n}\n\n.mh-table__zone {\n  font-size: 10px;\n  background: var(--mh-hall);\n  border-radius: 4px;\n  padding: 2px 6px;\n  color: var(--mh-muted);\n}\n\n.mh-hall__coach-hud {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-top: 14px;\n  padding-top: 10px;\n  border-top: 1px solid var(--mh-line);\n}\n\n.mh-hall__coach-badge {\n  font-size: 11px;\n  font-weight: 700;\n  color: var(--mh-blue);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.mh-hall__subtext {\n  font-size: 11px;\n  color: var(--mh-muted);\n}\n\n/* ==========================================================================\n   PROOF TICKER\n   ========================================================================== */\n\n.mh-proof {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px 24px;\n  padding: 12px 0 48px;\n  border-bottom: 1px solid var(--mh-line);\n}\n\n.mh-proof span {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--mh-navy);\n}\n\n/* ==========================================================================\n   SECTIONS & GRIDS\n   ========================================================================== */\n\n.mh-section {\n  padding: 80px 0;\n}\n\n.mh-section--navy {\n  background: var(--mh-navy);\n  color: #f4f7fb;\n}\n\n.mh-section--navy .mh-eyebrow {\n  color: #9fd4f0;\n}\n\n.mh-section--navy h2,\n.mh-section--navy h3 {\n  color: #fff;\n}\n\n.mh-section--navy .mh-lead,\n.mh-section--navy > .mh-wrap > p,\n.mh-section--navy .mh-note {\n  color: rgba(244, 247, 251, 0.82);\n}\n\n.mh-section--navy .mh-card h3 {\n  color: var(--mh-navy);\n}\n\n.mh-section--navy .mh-card p {\n  color: var(--mh-muted);\n}\n\n.mh-section h2 {\n  margin: 0 0 16px;\n  font-size: clamp(28px, 3.2vw, 40px);\n  letter-spacing: -0.03em;\n  line-height: 1.15;\n  color: var(--mh-navy);\n}\n\n.mh-grid-2 {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 36px;\n  align-items: start;\n}\n\n/* Problem Section Breakdown */\n.mh-problem-cards {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin-top: 24px;\n}\n\n.mh-problem-card {\n  background: var(--mh-white);\n  border: 1px solid var(--mh-line);\n  border-radius: 14px;\n  padding: 16px 20px;\n}\n\n.mh-problem-card strong {\n  display: block;\n  font-size: 15px;\n  margin-bottom: 4px;\n  color: var(--mh-navy);\n}\n\n.mh-problem-card p {\n  margin: 0;\n  font-size: 14px;\n  line-height: 1.5;\n  color: var(--mh-muted);\n}\n\n.mh-problem-card--stt {\n  border-color: rgba(8, 119, 188, 0.35);\n  background: rgba(8, 119, 188, 0.04);\n}\n\n.mh-problem-card--stt strong {\n  color: var(--mh-blue);\n}\n\n/* The 4 Beats (How it works) */\n.mh-beats {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 18px;\n  margin-top: 32px;\n}\n\n.mh-beat {\n  background: var(--mh-white);\n  border-radius: 16px;\n  padding: 22px;\n  border: 1px solid var(--mh-line);\n}\n\n.mh-beat__n {\n  font-size: 12px;\n  font-weight: 700;\n  color: var(--mh-blue);\n  letter-spacing: 0.08em;\n}\n\n.mh-beat h3,\n.mh-card h3 {\n  margin: 10px 0 8px;\n  font-size: 18px;\n  color: var(--mh-navy);\n}\n\n.mh-beat p,\n.mh-card p {\n  margin: 0;\n  font-size: 14px;\n  line-height: 1.55;\n  color: var(--mh-muted);\n}\n\n.mh-cards-3 {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 18px;\n  margin-top: 28px;\n}\n\n.mh-card {\n  background: var(--mh-white);\n  border-radius: 16px;\n  padding: 24px;\n  border: 1px solid var(--mh-line);\n  transition: transform 0.35s var(--mh-ease);\n}\n\n.mh-card:hover {\n  transform: translateY(-3px);\n}\n\n.mh-note {\n  margin: 20px 0 0;\n  font-size: 14px;\n  color: var(--mh-muted);\n}\n\n.mh-roles {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 18px;\n  margin-top: 28px;\n}\n\n/* ==========================================================================\n   THE FOUR FLOWS\n   ========================================================================== */\n\n.mh-flow-board {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 20px;\n  margin-top: 28px;\n}\n\n.mh-flow-card {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  text-decoration: none;\n  color: inherit;\n  background: var(--mh-white);\n  border-radius: 20px;\n  padding: 24px;\n  border: 1px solid var(--mh-line);\n  border-top: 4px solid var(--flow-accent, var(--mh-blue));\n  transition: transform 0.3s var(--mh-ease), box-shadow 0.3s var(--mh-ease);\n}\n\n.mh-flow-card:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 12px 28px rgba(11, 31, 51, 0.08);\n}\n\n.mh-flow-card__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.mh-flow-card h3 {\n  margin: 0;\n  font-size: 24px;\n  color: var(--mh-navy);\n}\n\n.mh-flow-card__badge {\n  font-size: 11px;\n  font-weight: 700;\n  background: var(--mh-hall);\n  border: 1px solid var(--mh-line);\n  border-radius: 999px;\n  padding: 3px 10px;\n  color: var(--mh-navy);\n}\n\n.mh-flow-card__mission {\n  margin: 0;\n  font-size: 14px;\n  line-height: 1.5;\n  color: var(--mh-muted);\n}\n\n.mh-flow-card__commitment {\n  background: rgba(11, 31, 51, 0.06);\n  border-radius: 8px;\n  padding: 6px 10px;\n  font-size: 12px;\n  color: var(--mh-navy);\n}\n\n.mh-kws {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.mh-kws li {\n  font-size: 12px;\n  background: var(--mh-hall);\n  border-radius: 999px;\n  padding: 4px 10px;\n  color: var(--mh-navy);\n}\n\n.mh-flow-link {\n  margin-top: auto;\n  font-size: 14px;\n  font-weight: 700;\n  color: var(--flow-accent, var(--mh-blue));\n}\n\n.mh-fork {\n  margin-top: 24px;\n  font-size: 14px;\n  color: var(--mh-muted);\n}\n\n/* ==========================================================================\n   SCFORH & ONE HEALTH SHOWCASE\n   ========================================================================== */\n\n.mh-scforh-pillars {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 20px;\n  margin: 32px 0;\n}\n\n.mh-scforh-pillar {\n  background: var(--mh-white);\n  border: 1px solid var(--mh-line);\n  border-radius: 18px;\n  padding: 24px;\n  transition: transform 0.3s var(--mh-ease);\n}\n\n.mh-scforh-pillar:hover {\n  transform: translateY(-3px);\n}\n\n.mh-scforh-pillar__icon {\n  font-size: 32px;\n  margin-bottom: 12px;\n}\n\n.mh-scforh-pillar h3 {\n  margin: 0 0 8px;\n  font-size: 18px;\n  color: var(--mh-navy);\n}\n\n.mh-scforh-pillar p {\n  margin: 0;\n  font-size: 14px;\n  line-height: 1.55;\n  color: var(--mh-muted);\n}\n\n.mh-scforh-principles {\n  background: var(--mh-white);\n  border: 1px solid var(--mh-line);\n  border-radius: 18px;\n  padding: 24px;\n  margin-bottom: 28px;\n}\n\n.mh-scforh-principles h3 {\n  margin: 0 0 16px;\n  font-size: 17px;\n  color: var(--mh-navy);\n}\n\n.mh-scforh-principles__grid {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.mh-scforh-tag {\n  font-size: 13px;\n  background: rgba(15, 123, 108, 0.08);\n  border: 1px solid rgba(15, 123, 108, 0.2);\n  color: var(--mh-sage);\n  border-radius: 999px;\n  padding: 6px 14px;\n  font-weight: 500;\n}\n\n/* SmartTTClub Breakdown: SMART + TT + Club (One Health) */\n.mh-brand-meaning {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 16px;\n  margin: 20px 0 28px;\n}\n\n.mh-brand-meaning__card {\n  background: var(--mh-white);\n  border: 1px solid var(--mh-line);\n  border-radius: 18px;\n  padding: 22px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.mh-brand-meaning__card--onehealth {\n  border-color: rgba(15, 123, 108, 0.3);\n  background: rgba(15, 123, 108, 0.03);\n}\n\n.mh-brand-meaning__tag {\n  align-self: flex-start;\n  font-size: 12px;\n  font-weight: 800;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n  background: var(--mh-hall);\n  border: 1px solid var(--mh-line);\n  color: var(--mh-blue);\n  padding: 4px 10px;\n  border-radius: 999px;\n}\n\n.mh-brand-meaning__tag--onehealth {\n  background: rgba(15, 123, 108, 0.1);\n  color: var(--mh-sage);\n  border-color: rgba(15, 123, 108, 0.25);\n}\n\n.mh-brand-meaning__card h4 {\n  margin: 0;\n  font-size: 16px;\n  color: var(--mh-navy);\n}\n\n.mh-brand-meaning__card p {\n  margin: 0;\n  font-size: 13px;\n  line-height: 1.55;\n  color: var(--mh-muted);\n}\n\n/* S.M.A.R.T. 5-Letter Cards */\n.mh-smart {\n  display: grid;\n  grid-template-columns: repeat(5, 1fr);\n  gap: 14px;\n  margin-top: 24px;\n}\n\n.mh-smart article {\n  background: var(--mh-white);\n  border: 1px solid var(--mh-line);\n  border-radius: 16px;\n  padding: 18px;\n}\n\n.mh-smart h3 {\n  margin: 0 0 8px;\n  font-size: 16px;\n  color: var(--mh-navy);\n}\n\n.mh-smart p {\n  margin: 0;\n  font-size: 13px;\n  line-height: 1.5;\n  color: var(--mh-muted);\n}\n\n/* ==========================================================================\n   PILOT INQUIRY FORM & SPLIT\n   ========================================================================== */\n\n.mh-pilot-split {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 40px;\n  align-items: start;\n}\n\n.mh-dl {\n  margin: 0;\n}\n\n.mh-dl dt {\n  margin-top: 18px;\n  font-weight: 700;\n  color: var(--mh-navy);\n}\n\n.mh-dl dd {\n  margin: 6px 0 0;\n  color: var(--mh-muted);\n  line-height: 1.55;\n  font-size: 15px;\n}\n\n.mh-form {\n  background: var(--mh-white);\n  border: 1px solid var(--mh-line);\n  border-radius: 20px;\n  padding: 26px;\n  display: grid;\n  gap: 14px;\n  box-shadow: 0 8px 24px rgba(11, 31, 51, 0.04);\n}\n\n.mh-form__row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n}\n\n.mh-form label {\n  display: grid;\n  gap: 6px;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--mh-navy);\n}\n\n.mh-form input,\n.mh-form select,\n.mh-form textarea {\n  font: inherit;\n  font-weight: 400;\n  border: 1px solid var(--mh-line);\n  border-radius: 12px;\n  padding: 10px 14px;\n  background: var(--mh-hall);\n  color: var(--mh-ink);\n}\n\n.mh-form__error {\n  margin: 0;\n  color: #9b1c1c;\n  font-size: 14px;\n}\n\n.mh-form__thanks {\n  background: var(--mh-peach);\n  border-radius: 16px;\n  padding: 24px;\n  color: var(--mh-navy);\n  line-height: 1.55;\n}\n\n/* ==========================================================================\n   FAQ & CTA\n   ========================================================================== */\n\n.mh-faq details {\n  border-bottom: 1px solid var(--mh-line);\n  padding: 16px 0;\n}\n\n.mh-faq summary {\n  cursor: pointer;\n  font-weight: 600;\n  color: var(--mh-navy);\n  font-size: 16px;\n}\n\n.mh-faq p {\n  margin: 12px 0 0;\n  color: var(--mh-muted);\n  line-height: 1.6;\n  font-size: 15px;\n}\n\n.mh-cta {\n  text-align: center;\n  padding: 80px 0 48px;\n}\n\n.mh-cta h2 {\n  margin-bottom: 12px;\n}\n\n/* ==========================================================================\n   FOOTER\n   ========================================================================== */\n\n.mh-footer {\n  background: var(--mh-navy);\n  color: rgba(244, 247, 251, 0.8);\n  padding: 48px 0;\n}\n\n.mh-footer__grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 28px;\n}\n\n.mh-footer__logo {\n  height: 32px;\n  width: auto;\n  filter: brightness(0) invert(1);\n}\n\n.mh-footer__tag {\n  margin: 14px 0 0;\n  max-width: 38ch;\n  line-height: 1.5;\n  font-size: 14px;\n}\n\n.mh-footer a {\n  color: #9fd4f0;\n}\n\n.mh-footer .mh-legal,\n.mh-footer .legal-footer {\n  margin-top: 14px;\n  justify-content: flex-start;\n  color: rgba(244, 247, 251, 0.75);\n}\n\n.mh-footer .mh-legal a,\n.mh-footer .legal-footer a {\n  color: #9fd4f0;\n}\n\n/* ==========================================================================\n   FLOW STORY PAGE\n   ========================================================================== */\n\n.mh-flow-page {\n  padding: 48px 0 80px;\n}\n\n.mh-flow-page__mark {\n  width: 52px;\n  height: 8px;\n  border-radius: 999px;\n  background: var(--flow-accent, var(--mh-blue));\n  margin-bottom: 16px;\n}\n\n.mh-pro-commitment-banner {\n  background: rgba(11, 31, 51, 0.06);\n  border-left: 4px solid var(--mh-navy);\n  padding: 12px 18px;\n  border-radius: 8px;\n  margin: 20px 0;\n  color: var(--mh-navy);\n}\n\n.mh-flow-story-body p {\n  font-size: 17px;\n  line-height: 1.7;\n  color: var(--mh-muted);\n}\n\n.mh-flow-detail-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 20px;\n  margin-top: 32px;\n}\n\n.mh-flow-detail-card {\n  background: var(--mh-white);\n  border: 1px solid var(--mh-line);\n  border-radius: 16px;\n  padding: 22px;\n}\n\n.mh-flow-detail-card p {\n  margin: 0;\n  font-size: 15px;\n  line-height: 1.55;\n  color: var(--mh-muted);\n}\n\n.mh-flow-others {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin-top: 28px;\n}\n\n/* ==========================================================================\n   MOBILE FLOATING STICKY ACTION BAR\n   ========================================================================== */\n\n.mh-mobile-sticky-bar {\n  display: none;\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 60;\n  background: rgba(255, 255, 255, 0.94);\n  backdrop-filter: blur(16px);\n  -webkit-backdrop-filter: blur(16px);\n  border-top: 1px solid var(--mh-line);\n  padding: 10px 18px;\n  box-shadow: 0 -4px 16px rgba(11, 31, 51, 0.08);\n}\n\n.mh-mobile-sticky-bar__inner {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n}\n\n.mh-mobile-sticky-bar__text {\n  font-size: 13px;\n  font-weight: 700;\n  color: var(--mh-navy);\n}\n\n/* ==========================================================================\n   RESPONSIVE MEDIA QUERIES (Mobile & Tablet)\n   ========================================================================== */\n\n@media (max-width: 960px) {\n  .mh-nav__links {\n    display: none;\n  }\n\n  .mh-nav__burger {\n    display: inline-flex;\n  }\n\n  /* Keep Sign in / Sign up in the top bar; pilot lives in the drawer + sticky bar */\n  .mh-nav__pilot {\n    display: none;\n  }\n\n  .mh-nav__inner {\n    width: min(1120px, calc(100% - 24px));\n    min-height: 64px;\n    gap: 12px;\n  }\n\n  .mh-nav__brand img {\n    height: 30px;\n  }\n\n  .mh-nav__actions {\n    gap: 6px;\n  }\n\n  .mh-hero,\n  .mh-grid-2,\n  .mh-pilot-split,\n  .mh-footer__grid {\n    grid-template-columns: 1fr;\n  }\n\n  .mh-beats,\n  .mh-cards-3,\n  .mh-roles,\n  .mh-smart,\n  .mh-brand-meaning,\n  .mh-flow-board,\n  .mh-scforh-pillars,\n  .mh-flow-detail-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .mh-hero {\n    padding-top: 32px;\n  }\n\n  .mh-hall {\n    min-height: 340px;\n  }\n\n  .mh-hall__mock {\n    margin: 14px 12px;\n    padding: 14px;\n  }\n\n  .mh-hall__grid {\n    grid-template-columns: 1fr;\n  }\n\n  .mh-mobile-sticky-bar {\n    display: block;\n  }\n\n  main {\n    padding-bottom: 50px;\n  }\n}\n\n@media (max-width: 640px) {\n  .mh-form__row {\n    grid-template-columns: 1fr;\n  }\n\n  /* Language moves into the drawer so auth CTAs stay visible top-right */\n  .mh-lang--bar {\n    display: none;\n  }\n\n  .mh-lang--drawer {\n    display: block;\n  }\n\n  .mh-nav__actions .mh-nav__auth {\n    padding: 7px 12px;\n    font-size: 12px;\n    min-height: 34px;\n  }\n\n  .mh-wrap {\n    width: min(1120px, calc(100% - 28px));\n  }\n\n  .mh-hero h1 {\n    font-size: 32px;\n  }\n\n  .mh-hero__ctas {\n    flex-direction: column;\n  }\n\n  .mh-hero__ctas .mh-btn,\n  .mh-cta .mh-btn,\n  .mh-section .mh-btn,\n  .mh-nav__mobile-actions .mh-btn {\n    width: 100%;\n  }\n\n  .mh-nav__actions .mh-btn {\n    width: auto;\n  }\n\n  .mh-mobile-sticky-bar .mh-btn {\n    width: auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
